import { render, staticRenderFns } from "./estabelecimento-container.vue?vue&type=template&id=bd67e23a&"
import script from "./estabelecimento-container.vue?vue&type=script&lang=ts&"
export * from "./estabelecimento-container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd67e23a')) {
      api.createRecord('bd67e23a', component.options)
    } else {
      api.reload('bd67e23a', component.options)
    }
    module.hot.accept("./estabelecimento-container.vue?vue&type=template&id=bd67e23a&", function () {
      api.rerender('bd67e23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/estabelecimento/estabelecimento-container.vue"
export default component.exports